import { z } from "zod";

const bookingsTabSchema = z.enum(["upcoming", "past", "cancelled"]);

export type BookingsTabValue = z.infer<typeof bookingsTabSchema>;

export const DEFAULT_BOOKINGS_TAB: BookingsTabValue = "upcoming";

export const bookingsListSearchSchema = z.object({
  tab: bookingsTabSchema.default(DEFAULT_BOOKINGS_TAB).catch(DEFAULT_BOOKINGS_TAB),
});

export type BookingsListSearch = z.infer<typeof bookingsListSearchSchema>;

export const bookingDetailSearchSchema = z.object({
  cancel: z.enum(["1"]).optional(),
  fromTab: bookingsTabSchema.optional(),
});

export type BookingDetailSearch = z.infer<typeof bookingDetailSearchSchema>;

export function bookingsListSearch(
  tab: BookingsTabValue = DEFAULT_BOOKINGS_TAB,
): BookingsListSearch {
  return { tab };
}

/** Search params for `/bookings/$id` when opened from the list (omit when external). */
export function bookingDetailFromTabSearch(
  fromTab: BookingsTabValue,
): Pick<BookingDetailSearch, "fromTab"> {
  return { fromTab };
}

export function timelineVariantToTab(variant: "upcoming" | "past" | "cancelled"): BookingsTabValue {
  return variant;
}
